import { render } from "./ViewPenyusunan.vue?vue&type=template&id=373a2a57"
import script from "./ViewPenyusunan.vue?vue&type=script&lang=js"
export * from "./ViewPenyusunan.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/pengadaan/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__